function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1443_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M56.5006 10.9997V3.9996C56.5006 2.34561 55.1546 1 53.5001 1H40.4996C38.8456 1 37.5 2.34561 37.5 3.9996V10.9997H56.5006ZM57.5006 11.9997H36.5V3.9996C36.5 1.791 38.291 0 40.4996 0H53.5001C55.7096 0 57.5006 1.791 57.5006 3.9996V11.9997Z",
  fill: "#1C0F59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.5 63C61.4117 63 73.5 50.9117 73.5 36C73.5 21.0883 61.4117 9 46.5 9C31.5883 9 19.5 21.0883 19.5 36C19.5 50.9117 31.5883 63 46.5 63Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.5 62.5C61.1355 62.5 73 50.6355 73 36C73 21.3645 61.1355 9.5 46.5 9.5C31.8645 9.5 20 21.3645 20 36C20 50.6355 31.8645 62.5 46.5 62.5Z",
  stroke: "#1C0F59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 43C50.1421 43 53.5 39.6421 53.5 35.5C53.5 31.3579 50.1421 28 46 28C41.8579 28 38.5 31.3579 38.5 35.5C38.5 39.6421 41.8579 43 46 43Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 42.5C49.866 42.5 53 39.366 53 35.5C53 31.634 49.866 28.5 46 28.5C42.134 28.5 39 31.634 39 35.5C39 39.366 42.134 42.5 46 42.5Z",
  stroke: "#1C0F59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.5078 30.1874L57.7538 23.9414",
  stroke: "#1C0F59",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.5 19H22.5C20.8431 19 19.5 20.3431 19.5 22V49C19.5 50.6569 20.8431 52 22.5 52H30.5C32.1569 52 33.5 50.6569 33.5 49V22C33.5 20.3431 32.1569 19 30.5 19Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 25H31.5",
  stroke: "#1C0F59",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5 36H31.5",
  stroke: "#1C0F59",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 46H31.5",
  stroke: "#1C0F59",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 40C48.4853 40 50.5 37.9853 50.5 35.5C50.5 33.0147 48.4853 31 46 31C43.5147 31 41.5 33.0147 41.5 35.5C41.5 37.9853 43.5147 40 46 40Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 39.5C48.2091 39.5 50 37.7091 50 35.5C50 33.2909 48.2091 31.5 46 31.5C43.7909 31.5 42 33.2909 42 35.5C42 37.7091 43.7909 39.5 46 39.5Z",
  stroke: "#1C0F59"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1443_2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 73.5,
  height: 63,
  fill: "white"
})));

function SvgQuickanother(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 63,
    viewBox: "0 0 74 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickanother);
export default __webpack_public_path__ + "static/media/quickanother.fae805f0803f144f7c51244d03de4973.svg";
export { ForwardRef as ReactComponent };